import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu2',
  templateUrl: './menu2.component.html',
  styleUrls: ['./menu2.component.scss']
})
export class Menu2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  openLunchMenu() {
    window.open("/assets/pdf/LunchMenu.pdf", '_blank');
  }

  openMainMenu() {
    window.open("/assets/pdf/Golden Express Menu_Nov22_v5.pdf", '_blank');
  }

  openTakeawayMenu() {
    window.open("/assets/pdf/TA_Menu.pdf", '_blank');
  }

}
